// app/redux/sagas/demandesSaga.js

import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    // types
    GET_MY_DEMANDES_REQUEST,
    GET_CREATED_BY_ME_DEMANDES_REQUEST,

    CREATE_DEMANDE_COLLAB_REQUEST,
    CREATE_DEMANDE_MANAGER_REQUEST,
    CREATE_DEMANDE_RF_REQUEST,

    CREATE_DEMANDE_MANAGER_BULK_REQUEST,
    CREATE_DEMANDE_RF_BULK_REQUEST,

    GET_DEMANDE_MANAGER_INBOX_REQUEST,
    GET_DEMANDE_RF_INBOX_REQUEST,

    DEMANDE_MANAGER_DECISION_REQUEST,
    DEMANDE_RF_DECISION_REQUEST,

    // common
    setDemandeLoading,

    // list
    getMyDemandesSuccess,
    getMyDemandesFail,
    getCreatedByMeDemandesSuccess,
    getCreatedByMeDemandesFail,

    // create
    createDemandeCollabSuccess,
    createDemandeCollabFail,
    createDemandeManagerSuccess,
    createDemandeManagerFail,
    createDemandeRfSuccess,
    createDemandeRfFail,

    // bulk
    createDemandeManagerBulkSuccess,
    createDemandeManagerBulkFail,
    createDemandeRfBulkSuccess,
    createDemandeRfBulkFail,

    // inbox
    getDemandeManagerInboxSuccess,
    getDemandeManagerInboxFail,
    getDemandeRfInboxSuccess,
    getDemandeRfInboxFail,

    // decisions
    demandeManagerDecisionSuccess,
    demandeManagerDecisionFail,
    demandeRfDecisionSuccess,
    demandeRfDecisionFail, getCompanyDemandesFail, getCompanyDemandesSuccess, DOWNLOAD_PLAN_FORMATION_SUCCESS,
    DOWNLOAD_PLAN_FORMATION_FAIL, DOWNLOAD_BILAN_FORMATION_SUCCESS, DOWNLOAD_BILAN_FORMATION_FAIL,
} from "../actions/demandesActions";

import {API_BASE_URL, getBlobRequest, getRequest, postRequest} from "../../../api";
import {
    DOWNLOAD_DOMAINES_TEMPLATE_FAIL,
    DOWNLOAD_DOMAINES_TEMPLATE_SUCCESS
} from "../actions/paramDomainesThemesActions";

const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (data?.message) return String(data.message);
    if (data?.error) return String(data.error);
    if (error?.message) return String(error.message);
    try {
        if (data && typeof data === "object") return JSON.stringify(data);
    } catch {}
    return fallback;
};

// ===================== WORKERS =====================

export function* getMyDemandesSaga() {
    const url = `${API_BASE_URL}/api/demandes/my`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getMyDemandesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes");
        yield put(getMyDemandesFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getCreatedByMeDemandesSaga() {
    const url = `${API_BASE_URL}/api/demandes/created-by-me`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getCreatedByMeDemandesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes (créées par moi)");
        yield put(getCreatedByMeDemandesFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

// ---- CREATE (3 modes) ----

export function* createDemandeCollabSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/collaborateur`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeCollabSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande envoyée avec succès",
            timer: 1700,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_DEMANDES_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création demande");
        yield put(createDemandeCollabFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createDemandeManagerSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/manager`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeManagerSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande créée (manager)",
            timer: 1600,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST }); // utile si "Les deux" ou "Responsable de formation"
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création demande manager");
        yield put(createDemandeManagerFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createDemandeRfSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/rf`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeRfSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande créée ",
            timer: 1600,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création demande");
        yield put(createDemandeRfFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

// ---- BULK ----

export function* createDemandeManagerBulkSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/manager/bulk`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeManagerBulkSuccess(resp.data || []));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demandes envoyées",
            timer: 1700,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur lors de création des demandes");
        yield put(createDemandeManagerBulkFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createDemandeRfBulkSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/rf/bulk`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeRfBulkSuccess(resp.data || []));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demandes envoyées",
            timer: 1700,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur lors de création des demandes");
        yield put(createDemandeRfBulkFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

// ---- INBOX ----

export function* getDemandeManagerInboxSaga() {
    const url = `${API_BASE_URL}/api/demandes/inbox/manager`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getDemandeManagerInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox manager");
        yield put(getDemandeManagerInboxFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getDemandeRfInboxSaga() {
    const url = `${API_BASE_URL}/api/demandes/inbox/rf`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getDemandeRfInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox RF");
        yield put(getDemandeRfInboxFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

// ---- DECISIONS ----

export function* demandeManagerDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, approved, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/demandes/${id}/manager-decision`;

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: { approved, comment }, headers: { uid } });
        yield put(demandeManagerDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision manager envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_DEMANDE_MANAGER_INBOX_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST }); // si "Les deux" -> passe chez RF
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision manager");
        yield put(demandeManagerDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* demandeRfDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, approved, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/demandes/${id}/rf-decision`;

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: { approved, comment }, headers: { uid } });
        yield put(demandeRfDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision responsable formation envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision responsable formation");
        yield put(demandeRfDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getCompanyDemandesSaga() {
    const url = `${API_BASE_URL}/api/demandes/company`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getCompanyDemandesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes société");
        yield put(getCompanyDemandesFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

function downloadBlobAsFile(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

export function* downloadGeneratePlanFormationExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const url = `${API_BASE_URL}/api/demandes/excel/bilan/formation/${action.cid}`;



        const res = yield call(getBlobRequest, {
            url,
            token,
            extraHeaders: {
                uid,
                "X-Tenant-Id": sessionStorage.getItem('selectedCompanyId'),
            },
        });

        downloadBlobAsFile(new Blob([res.data]), "Plan_formation.xlsx");
        yield put({ type: DOWNLOAD_PLAN_FORMATION_SUCCESS });
    } catch (e) {
        yield put({
            type: DOWNLOAD_PLAN_FORMATION_FAIL,
            payload: e.response?.data || e.message,
        });

        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template domaines échoué" });
    }
}


export function* downloadGenerateBilanCampagneExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const url = `${API_BASE_URL}/api/demandes/excel/bilan/${action.cid}`;



        const res = yield call(getBlobRequest, {
            url,
            token,
            extraHeaders: {
                uid,
                "X-Tenant-Id": sessionStorage.getItem('selectedCompanyId'),
            },
        });

        downloadBlobAsFile(new Blob([res.data]), "Bilan_Formation.xlsx");
        yield put({ type: DOWNLOAD_BILAN_FORMATION_SUCCESS });
    } catch (e) {
        yield put({
            type: DOWNLOAD_BILAN_FORMATION_FAIL,
            payload: e.response?.data || e.message,
        });

        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template domaines échoué" });
    }
}


// ===================== WATCHERS =====================
